export default __webpack_public_path__ + "static/media/SampleASINSKUMapping.d506fc52.xlsx";